export const PonSpinner = () => import(/* webpackChunkName: "PonSpinner" */ './PonSpinner.vue')
export const ThreeSixtyViewer = () =>
  import(/* webpackChunkName: "ThreeSixtyViewer" */ './ThreeSixtyViewer.vue')

export default {
  PonSpinner,
}
